import React from "react";
import PropTypes from "prop-types";
import isUndefined from "lodash/isUndefined";

const onKeyDown = (props) => {
    if (!isUndefined(props.onClick)) {
        return (e) => {
            if (e.key === "Enter" || e.key === " ") {
                props.onClick(e);
                e.preventDefault();
            }
        };
    }
    return null;
};

/* <Buttonize> : Wrap layout items like <div>'s and <span>'s in order to turn them
** into buttons in a way that is compatible with screenreader applications
** Props:
**  label:string - The label assigned to the wrapped element. Will be read to
**      users by screenreader applications. Required.
**  onClick:func - Handler function, fires when wrapped element is clicked.
**      Takes an event object. Optional.
*/
class Buttonize extends React.Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func,
        pressed: PropTypes.bool
    }

    render() {
        return React.cloneElement(React.Children.only(this.props.children), {
            onClick: this.props.onClick,
            onKeyDown: onKeyDown(this.props),
            role: "button",
            tabIndex: 0,
            "aria-label": this.props.label,
            "aria-pressed": this.props.pressed
        });
    }
}

/* <Switchify> : Wrap layout items like <div>'s and <span>'s in order to turn them
** into switches in a way that is compatible with screenreader applications
** Props:
**  label:string - The label assigned to the wrapped element. Will be read to
**      users by screenreader applications. Required.
**  onClick:func - Handler function, fires when wrapped element is clicked.
**      Takes an event object. Optional.
**  switchOn:bool - State of the switch; true indicates "on"
*/
class Switchify extends React.Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func,
        switchOn: PropTypes.bool.isRequired,
        disabled: PropTypes.bool
    }

    render() {
        return React.cloneElement(React.Children.only(this.props.children), {
            onClick: this.props.onClick,
            onKeyDown: onKeyDown(this.props),
            role: "switch",
            "aria-checked": this.props.switchOn,
            tabIndex: 0,
            "aria-label": this.props.label,
            "aria-disabled": this.props.disabled
        });
    }
}

export {
    Buttonize,
    Switchify
};